import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { VerifiedGameClubSolid } from "@gaming/xds-react-js-icons";

import { xboxOnboardSiteLocationPrefix } from "../../constants";
import { useString } from "../../localization/localizationHelpers";
import { getXboxOnboardData } from "../../redux/selectors/xboxOnboardSelectors";
import * as styles from "./IdXboxBadge.module.css";

export const IdXboxBadge = () => {
  const label = useString("partnerHomeIdXboxBadgeLabel");
  const canSubmitIdApplication =
    useSelector(getXboxOnboardData)?.hubPermissions.canSubmitIdApplication === true;
  const content = (
    <>
      <Icon
        aria-hidden="true"
        className={styles.icon}
        icon={VerifiedGameClubSolid}
        iconSize={IconSize.Custom}
      />
      {label}
    </>
  );

  return canSubmitIdApplication ? (
    <Link className={styles.badge} to={`${xboxOnboardSiteLocationPrefix}/id`}>
      {content}
    </Link>
  ) : (
    <span className={styles.badge}>{content}</span>
  );
};
